"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backend = void 0;
var utils_1 = require("../../utils");
exports.backend = function (axios) {
    return {
        // Backend - 쿠폰발행
        getCoupons: function (request) {
            return axios.get('/coupons', request);
        },
        postCoupons: function (request) {
            return axios.post('/coupons', request.data);
        },
        postCouponsCheckPromotionCode: function (request) {
            return axios.post('/coupons/check-promotion-code', request.data);
        },
        getCouponsCount: function (request) {
            return axios.get('/coupons/count', request);
        },
        getCouponsCouponNo: function (request) {
            var url = utils_1.paramPathchange('/coupons/{couponNo}', request);
            return axios.get(url);
        },
        putCouponsCouponNo: function (request) {
            var url = utils_1.paramPathchange('/coupons/{couponNo}', request);
            return axios.put(url, request.data);
        },
        getCouponsCouponNoCodes: function (request) {
            var url = utils_1.paramPathchange('/coupons/{couponNo}/codes', request);
            axios.defaults.timeout = 30 * 60 * 1000;
            return axios
                .get(url)
                .then(function (res) {
                return res;
            })
                .finally(function () {
                axios.defaults.timeout = 30 * 1000;
            });
        },
        putCouponsCouponNoIssueStatus: function (request) {
            var url = utils_1.paramPathchange('/coupons/{couponNo}/issue-status', request);
            return axios.put(url, request.data);
        },
        getCouponsCouponNoSummary: function (request) {
            var url = utils_1.paramPathchange('/coupons/{couponNo}/summary', request);
            return axios.get(url, request);
        },
        putCouponsCouponNoUseStop: function (request) {
            var url = "/coupons/" + request.pathParams.couponNo + "/use-stop?useStopped=" + request.params.useStopped;
            return axios.put(url);
        },
        postCouponsCodesCouponNoGenerate: function (request) {
            var url = utils_1.paramPathchange('/coupons/codes/{couponNo}/generate', request);
            return axios.post(url, request.data);
        },
        getCouponsCodesCouponNoSearch: function (request) {
            var url = utils_1.paramPathchange('/coupons/codes/{couponNo}/search', request);
            return axios.get(url, request);
        },
        // Backend - 쿠폰지급설정
        getCouponsIssuePlans: function (request) {
            return axios.get('/coupons/issue-plans', request);
        },
        postCouponsIssuePlans: function (request) {
            return axios.post('/coupons/issue-plans', request.data);
        },
        getCouponsIssuePlansCouponIssuePlanNo: function (request) {
            var url = '/coupons/issue-plans/{couponIssuePlanNo}';
            url = utils_1.paramPathchange(url, request);
            return axios.get(url);
        },
        putCouponsIssuePlans: function (request) {
            var url = '/coupons/issue-plans/{couponIssuePlanNo}';
            url = utils_1.paramPathchange(url, request);
            return axios.put(url, request.data);
        },
        putCouponsIssuePlansTerminate: function (request) {
            var url = utils_1.paramPathchange('/coupons/issue-plans/{couponIssuePlanNo}/terminate', request);
            return axios.put(url);
        },
        getCouponsIssuePlansSummary: function (request) {
            var url = utils_1.paramPathchange('/coupons/issue-plans/{couponIssuePlanNo}/summary', request);
            return axios.get(url, request);
        },
        // Backend - 쿠폰 지급
        getCouponsIssue: function (request) {
            return axios.get('/coupons/issues', request);
        },
        postCouponsIssues: function (request) {
            return axios.post('/coupons/issues', request.data);
        },
        getCouponsIssueCheckIssuale: function (request) {
            return axios.get('/coupons/issues/not-issuable-coupons', request);
        },
        getCouponsIssueInMembers: function (request) {
            return axios.get('/coupons/issues/coupons-in-members', request);
        },
        // Backend - 쿠폰 사용
        getCouponsUse: function (request) {
            return axios.get('/coupons/use', request);
        },
        getCouponsIssuesSummary: function (request) {
            return axios.get('/coupons/issues/summary', request);
        },
        putCouponsIssuesCouponIssueNoWithdraw: function (request) {
            var url = '/coupons/issues/{couponIssueNo}/withdraw';
            url = utils_1.paramPathchange(url, request);
            return axios.put(url, request.data);
        },
        //쿠폰지급 설정 상태별 카운트
        getCouponsIssuePlansSummaryCount: function (request) {
            return axios.get('/coupons/issue-plans/summary-count', request);
        }
    };
};
